<template>
    <div class="has-clip">

    <div class="section-icons" :class="{
        'section-icons--dark has-wave': styled === 'yes',
        'section-icons--top': styled === 'no',
    }" :style="`--bg: ${background}`">
    
        <WithWave v-bind="{ styled }" />

        <div class="section-text__content has-overflow" v-if="title">
            <h2 class="title title--dash" v-html="title" />
            <div class="section__text" v-html="text" v-if="text" />
        </div>

        <div class="cards" :style="`--x: ${items_count}`">
            <div class="card" v-for="(icon, i) in items" :key="i">
                <img v-if="icon.icon" :src="icon.icon.url" width="56" height="56" alt />
                <p class="card__title" :class="{'card__title--xl': styled_headline}" v-if="icon.title" v-html="icon.title" />
                <p class="card__text" v-html="icon.text" v-if="icon.text" />
                <a v-if="icon.button && icon.button.url" :href="icon.button.url" target="_blank" rel="noopener">
                    <span class="sr-only" v-html="icon.title" />
                </a>
            </div>
        </div>
        
    </div>
    </div>
</template>

<script>
import { textProps, optionsProps } from './sectionProps'
import WithWave from './WithWave.vue';

export default {
    props: {
        styled: String,
        styled_headline: {
            type: Boolean,
            default: false,
        },
        items: {
            type: [Array, Boolean],
        },
        items_count: {
            type: Number,
            default: 3,
        },
        ...textProps,
        ...optionsProps,
    },

    components: {
        WithWave,
    },
}
</script>

<style lang="scss" scoped>
.section-icons {
    background-color: var(--bg);
    padding: 3rem 20px;
}

.section-icons.has-wave {
    margin-top: 15vw;
}

.section-icons--top {
    padding-top: 0 !important;
}

@media (width <= 767px) {
    ::v-deep .section-icons br {
        display: none;
    }
}

@media (width > 767px) {
    .section-icons {
        padding: 6rem 2rem;
    }
    .section-icons.has-wave {
        padding-block-start: 2rem;
    }
}

.section-icons--dark {
    --bg: var(--purple) !important;
    color: #fff;

    :is(h1, h2, h3, p, li) {
        color: currentColor;
    }
    :is(.card p) {
        color: var(--purple);
    }
    :is(.card .card__text) {
        color: #333;
    }
}

.cards {
    max-width: (1200px - 60);
    margin-inline: auto;
    display: grid;
    gap: 1rem;

    &[style*="3"] {
        max-width: 1364px;
    }
}

* ~ .cards {
    margin-top: 2rem;
}

.card {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 1em;
    padding: 1.5em 2.5em;
    gap: 1em;
    background: #fff;
    font-size: 1rem;
    box-shadow: 
        0 .1rem .1rem rgba(60, 32, 100, 0.07),
        0 .25rem 1.5rem rgba(60, 32, 100, 0.15);
    position: relative;
    --outline-offset: -4px;
    --btn-outline-color: var(--purple);

    a {
        border-radius: inherit;
        text-align: center;
        position: absolute;
        inset: 0;
    }

    img {
        width: 2.25em;
        height: auto;
        transition: scale .2s
    }
}

.card__title {
    font-size: 1.1em;
    text-align: center;
    text-wrap: balance;
    color: var(--purple);
}

.card__title--xl {
    font-size: 3rem;
}

.card__text {
    font-size: 1rem;
    line-height: 1.5;
    text-align: center;
    color: #222;
}

@media (width > 767px) {
    * ~ .cards {
        margin-top: 4rem;
    }
    .cards {
        grid-template-columns: repeat(var(--x), 1fr);
    }
    .card {
        flex-basis: 100%;
    }
    .card:has(a):hover img {
        scale: 1.075
    }
}
@media (width > 1280px) {
    .cards {
        gap: 2rem;
    }
    .card {
        font-size: 1.5rem;
    }
}
</style>